import React, { useState } from 'react';
import { FormControl } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ConfirmIcon from '@mui/icons-material/Check';
import Fab from '@mui/material/Fab';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useIFPRSGlobalContext } from "../../IFPRSGlobalContext";
import { Typography } from "@mui/material";
import {checkIfPointBuffer, generateFeatureCollectionFromShapefile} from "../../utils/UploadHelper";


export default function EditPerimeterToolbar({isTreatment, isActuals, onConfirmPerimeterEdit, onCancelPerimeterEdit, onUploadPerimeter, onClearChangesPerimeter, onReplacePerimeter }) {
  const [showShapeParseError, setShowShapeParseError] = useState(false);
  const [showEditGeometryError, setShowEditGeometryError] = useState(false);
  const inputReaderRef = React.useRef(null);
  const config = useSelector((state) => state.configuration.config)
  const uploadShapefile = () => {
    inputReaderRef.current.click();
  }
  const { setAlertMessageObj } = useIFPRSGlobalContext();

  const shapefileChanged = async (e) => {
    const file = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
    if (file) {
      const parseSuccess = await generateFeatureCollection(file);
    }
    inputReaderRef.current.value = "";
  };

  const generateFeatureCollection = (file) => {
    generateFeatureCollectionFromShapefile(file, config).then(tempPerimeter => {
      if (tempPerimeter) {
        try {
          // Create point buffer polygon for New Fuel Activities
          const perimeter = checkIfPointBuffer(tempPerimeter, isActuals, isTreatment);
          onUploadPerimeter(perimeter);
          setShowShapeParseError(false);
          setShowEditGeometryError(false);
          return perimeter;
        } catch (e) {
          setShowEditGeometryError(true);
        }
      }
    });
  }

  useEffect(() => {
    if (showShapeParseError) {
      setAlertMessageObj({
        message: "Shapefile Parse Error",
        severity: "error",
        child: (
          <Typography sx={{ marginLeft: "5px", marginRight: "5px" }}>
            Unable to parse shapefile or found empty geometry. Please verify .zip contents and geometry and try again.
          </Typography>
        ),
        callback: null
      });
    }

    // Cleanup function to reset showShapeParseError to false
    return () => {
      setShowShapeParseError(false);
    };
  }, [showShapeParseError, setAlertMessageObj]);

  useEffect(() => {
    if (showEditGeometryError) {
      setAlertMessageObj({
        message: 'Edit Geometry Error',
        severity: "error",
        child: (
          <Typography sx={{ marginLeft: "5px", marginRight: "5px" }}>
            Uploaded geometry type does not match the existing feature. Please verify .zip contents and try again.
          </Typography>
        ),
        callback: null
      });
    }
    // Cleanup function to reset showEditGeometryError to false
    return () => {
      setShowEditGeometryError(false);
    };
  }, [showEditGeometryError, setAlertMessageObj]);

  return (
    <div>
      <Fab style={{ padding: '0 10px', marginBottom: 3 }} variant="extended" size="medium" color="primary" aria-label="Upload" onClick={() => {
        uploadShapefile();
        setShowShapeParseError(false);
        setShowEditGeometryError(false);
      }}>
        <UploadFileIcon sx={{ mr: 1 }} />
        Upload
      </Fab>
      <Fab style={{ padding: '0 10px', marginLeft: 3, marginBottom: 3 }} variant="extended" size="medium" color="primary" aria-label="Copy" onClick={onReplacePerimeter}>
        <FindReplaceIcon sx={{ mr: 1 }} />
        Copy
      </Fab>
      <Fab style={{ padding: '0 10px', marginLeft: 3, marginBottom: 3 }} variant="extended" size="medium" color="primary" aria-label="Upload" onClick={onClearChangesPerimeter}>
        <DeleteIcon sx={{ mr: 1 }} />
        Clear Changes
      </Fab>
      <Fab style={{ padding: '0 10px', marginLeft: 3, marginBottom: 3 }} variant="extended" size="medium" color="primary" aria-label="Cancel" onClick={onCancelPerimeterEdit}>
        <CloseIcon sx={{ mr: 1 }} />
        Cancel
      </Fab>
      <Fab style={{ padding: '0 10px', marginLeft: 3, marginBottom: 3 }} variant="extended" size="medium" color="primary" aria-label="Confirm" onClick={onConfirmPerimeterEdit}>
        <ConfirmIcon sx={{ mr: 1 }} />
        Confirm
      </Fab>
      <FormControl>
        <input type="file" ref={inputReaderRef} accept=".zip" multiple={false} style={{ display: 'none' }} onChange={shapefileChanged} />
      </FormControl>
    </div>
  )
}